"use client";
import React from "react";

export type ThemeMode = "light" | "dark";

export type ThemeContextState = {
  mode: ThemeMode;
  setMode: (m: ThemeMode) => void;
};

const ThemeContext = React.createContext<ThemeContextState | null>(null);

export function useThemeContext() {
  const ctx = React.useContext(ThemeContext);
  if (!ctx) throw new Error("useThemeContext must be used within ThemeProvider");
  return ctx;
}

export default ThemeContext;
